import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import messagesTicket from "../../../messages/ticket";
import Pagination from "./Pagination";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";

function UserTickets() {
  const [userTickets, setUserTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [titleTicketSearchFilter, setTitleTicketSearchFilter] = useState();

  useEffect(() => {
    getUserTickets();
  }, []);

  useEffect(() => {
    getUserTickets();
  }, [currentPage, countItemPerPage, titleTicketSearchFilter]);

  const getUserTickets = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetUserTicketUserTickets =
      await sendRequestGetUserTickets(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetUserTicketUserTickets) {
      return;
    }

    setUserTickets(resultSendRequestGetUserTicketUserTickets.tickets);
    setCountPage(resultSendRequestGetUserTicketUserTickets.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (titleTicketSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&title=${titleTicketSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetUserTickets = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let userTickets;
    try {
      userTickets = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/ticket?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return userTickets.data.data;
  };

  const generateTickets = () => {
    return (
      <>
        <div className="pb-2">
          <Link className="btn btn-success" to="/ticket/add">
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>درخواست پشتیبانی </span>
          </Link>
        </div>

        <div class="container-fluid">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در عنوان تیکت </label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="عنوان تیکت را در اینجا وارد کنید "
                  onKeyUp={(e) => setTitleTicketSearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space ">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تیکت</td>
                <td>عنوان تیکت</td>
                <td>دسته</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {userTickets.map((userTicket, index) => {
                return (
                  <tr key={index}>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{helperNumber.toPersianNum(userTicket.id)}</td>
                    <td>{userTicket.title}</td>
                    <td>{userTicket.category}</td>
                    <td>{setBadgeForStatus(userTicket.status)}</td>
                    <td>{helperNumber.toPersianNum(userTicket.createAt)}</td>

                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/ticket/view/${userTicket.id} `}
                            className="btn btn-success"
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const setBadgeForStatus = (statusTitle) => {
    let tagBadge;
    switch (statusTitle) {
      case messagesTicket.TICKET_STATE_PENDING:
        tagBadge = <span className="badge  badge-warning">{statusTitle}</span>;
        break;
      case messagesTicket.TICKET_STATE_ANSWERED:
        tagBadge = <span className="badge  badge-info">{statusTitle}</span>;
        break;
      case messagesTicket.TICKET_STATE_CLOSED:
        tagBadge = <span className="badge  badge-success">{statusTitle}</span>;
        break;
    }

    return tagBadge;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateUserDoNotHaveTicket = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-ticket.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر هیج درخواست پشتیبانی ندارید :(</p>
          <p>برای شروع کار یک درخواست پشتیبانی بسازید.</p>
          <div className="text-center text-md-right pt-2">
            <Link className="btn btn-success" to="/ticket/add">
              <span className="pl-2">
                <i className="fa fa-plus"></i>
              </span>
              <span>درخواست پشتیبانی </span>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="tickets" activeItem="all-user-tickets" />
      <div className="content-wrapper">
        <TitleBar title="درخواست پشتیبانی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {userTickets.length == 0 && titleTicketSearchFilter == null
                ? generateUserDoNotHaveTicket()
                : generateTickets()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default UserTickets;
